import React, { useState, useEffect } from "react";
import { Container, Image, Row, Col, Form, Button, Modal } from "react-bootstrap";
import "./EmailSignup.styles.scss";
import { closeIconLight, iconWarning } from "../../lib/images";
import * as qs from "qs";
import config from "../../lib/config";
import { useLocation, Link } from "react-router-dom";
import { useTranslation, Trans } from "react-i18next";

function AlertSignup(props) {
  const [showAlert, setShowAlert] = useState(true);
  const [showCountyModal, setShowCountyModal] = useState(false);
  const [status, setStatus] = useState("INITIAL");
  const [email, setEmail] = useState("");
  const [sourceParam, setSourceParam] = useState(sessionStorage.getItem(config.akSourceName));

  const { t } = useTranslation();
  const location = useLocation();
  const country = "United States";
  useEffect(() => {
    if (!sourceParam) setSourceParam(qs.parse(location.search, { ignoreQueryPrefix: true })[config.akSourceName]); // If no stored source exists, check QS. Use if found.
  }, [location, sourceParam]);

  const toggleAlert = () => {
    setShowAlert(false);
  };

  // Feature toggle: easily toggle back to normal mode via config.pollWorkerCountyAlert.enabled or props
  const isPollWorkerMode =
    props?.pollWorkerMode !== undefined
      ? props.pollWorkerMode
      : Boolean(config.pollWorkerCountyAlert?.enabled);

  const countiesList = config.pollWorkerCountyAlert?.counties || [];
  const countiesTickerString = countiesList.length > 0 ? countiesList.join(" • ") + " • " : "";
  const sortedCounties = [...countiesList].sort((a, b) => a.localeCompare(b));

  function handleSubmit(e) {
    // Migrated to AN payload structure and created a matching AN form. However, this function is currently unused since there is no email input in the alert.
    e.preventDefault();
    const payload = {
      person: {
        email_addresses: [{ address: email }],
        page: config.actionNetworkAlertBannerPage.Name,
        sourceref: sourceParam || undefined,
        country: country,
      },
    };

    const pageFormID = config.actionNetworkAlertBannerPage.ID;

    window.session.postSubscribeEmail(payload, pageFormID).then(
      function (res) {
        setStatus("SUCCESS");
      },
      function (e) {
        setStatus("FAILED");
      }
    );
  }

  // Standard / Normal alert mode
  const renderForm = (
    <Container fluid>
      <Row noGutters>
        <Col className="email-signup-input close-padding">
          <div className="action_form">
            <div className="ak-grid-row">
              <Container fluid className="alert-container-responsive">
                <Row noGutters className="form-email">
                  <Col className="alert-email-title">
                    <div className="alert-responsive">
                      <div>{t("help_staff_alert")}</div>
                      <div>
                        <Link to="/powerthepolls" className="alert-link-btn">
                          <button type="button" className="full btn-send-email">
                            {t("sign_up").toUpperCase()}
                          </button>
                        </Link>
                      </div>
                    </div>
                  </Col>
                </Row>
              </Container>
            </div>
          </div>
        </Col>
        <div className={"close-email-signup"}>
          <Image src={closeIconLight} className="btn-close-signup clickable" alt="" onClick={() => toggleAlert()} />
        </div>
      </Row>
    </Container>
  );

  // Option 4: Poll Worker County Recruitment Ticker Marquee + "View All" Modal
  const renderPollWorkerAlert = (
    <>
      <Container fluid className="poll-worker-alert-container">
        <Row noGutters className="align-items-center">
          <Col className="poll-worker-alert-col">
            {/* Desktop & Tablet View (>=768px): Single line layout */}
            <div className="poll-worker-ticker-wrapper d-none d-md-flex">
              <div className="ticker-label">
                <span>
                  {t(
                    "help_needed_in_counties",
                    "Help needed in the following Counties:"
                  )}
                </span>
              </div>

              <div
                className="ticker-track-container"
                tabIndex={0}
                role="region"
                aria-label={t(
                  "poll_worker_counties_alert_title",
                  "Counties needing poll workers"
                )}
                title="Hover or focus to pause scrolling"
              >
                <div className="ticker-track">
                  <span className="ticker-text">{countiesTickerString}</span>
                  <span className="ticker-text" aria-hidden="true">
                    {countiesTickerString}
                  </span>
                </div>
              </div>

              <div className="ticker-actions">
                <button
                  type="button"
                  className="btn-view-counties"
                  onClick={() => setShowCountyModal(true)}
                >
                  {t("view_all_counties", "View All")}
                </button>
                <Link to="/powerthepolls" className="alert-link-btn">
                  <button type="button" className="btn-send-email">
                    {t("sign_up", "Sign Up").toUpperCase()}
                  </button>
                </Link>
              </div>
            </div>

            {/* Mobile View (<768px): Two compact rows */}
            <div className="poll-worker-ticker-wrapper-mobile d-flex d-md-none">
              <div className="poll-worker-mobile-top">
                <span className="ticker-label-mobile">
                  {t("help_needed_in_counties_short", "Help in 31 Counties:")}
                </span>
                <div className="ticker-actions-mobile">
                  <button
                    type="button"
                    className="btn-view-counties"
                    onClick={() => setShowCountyModal(true)}
                  >
                    {t("view_all_counties", "View All")}
                  </button>
                  <Link to="/powerthepolls" className="alert-link-btn">
                    <button type="button" className="btn-send-email">
                      {t("sign_up", "Sign Up").toUpperCase()}
                    </button>
                  </Link>
                </div>
              </div>

              <div
                className="ticker-track-container"
                tabIndex={0}
                role="region"
                aria-label={t(
                  "poll_worker_counties_alert_title",
                  "Counties needing poll workers"
                )}
                title="Touch or hover to pause scrolling"
              >
                <div className="ticker-track">
                  <span className="ticker-text">{countiesTickerString}</span>
                  <span className="ticker-text" aria-hidden="true">
                    {countiesTickerString}
                  </span>
                </div>
              </div>
            </div>
          </Col>

          <div className="close-email-signup">
            <Image
              src={closeIconLight}
              className="btn-close-signup clickable"
              alt="Close Alert"
              onClick={() => toggleAlert()}
            />
          </div>
        </Row>
      </Container>

      {/* Accessible Counties Modal */}
      <Modal
        show={showCountyModal}
        onHide={() => setShowCountyModal(false)}
        centered
        size="lg"
        className="poll-worker-counties-modal"
        aria-labelledby="poll-worker-modal-title"
      >
        <Modal.Header closeButton>
          <Modal.Title id="poll-worker-modal-title">
            {t(
              "counties_needing_poll_workers",
              "Counties Needing Poll Workers"
            )}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className="modal-description">
            {t(
              "poll_workers_needed_desc",
              "Poll workers are urgently needed in these counties. Sign up to help staff your local polling place!"
            )}
          </p>
          <div className="counties-list-container">
            <ul className="counties-list">
              {sortedCounties.map((county) => (
                <li key={county} className="county-item">
                  {county}
                </li>
              ))}
            </ul>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            className="btn-modal-close"
            onClick={() => setShowCountyModal(false)}
          >
            {t("close", "Close")}
          </button>
          <Link
            to="/powerthepolls"
            className="alert-link-btn"
            onClick={() => setShowCountyModal(false)}
          >
            <button className="btn-modal-signup">
              {t("sign_up", "Sign Up").toUpperCase()}
            </button>
          </Link>
        </Modal.Footer>
      </Modal>
    </>
  );

  const renderStatus = (status) => {
    switch (status) {
      case "INITIAL":
        return isPollWorkerMode ? renderPollWorkerAlert : renderForm;
      case "SUCCESS":
        return <span className="alert-email-title">{t("thanks_check_your_email")}</span>;
      case "FAILED":
        return <span className="alert-email-title">There has been an issue, please try again.</span>;
      default:
        return isPollWorkerMode ? renderPollWorkerAlert : renderForm;
    }
  };

  if (showAlert) {
    return (
      <div className="ctn-email-signup">
        {renderStatus(status)}
      </div>
    );
  }
  return "";
}
export default AlertSignup;